import React, { useState, useEffect } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { fr } from "date-fns/locale";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import { AfficheDonner, ModificationDonner, ModificationPassword } from '../../Api/ClientApi/DonnerPersonneApi';

import './css/donnerClient.css';

const Donner = () => {

    const [naissance, setNaissance] = useState(new Date());
    const [sexe, setSexe] = useState([
        {
            id: 1,
            libelle: "Homme",
            status: false
        },
        {
            id: 2,
            libelle: "Femme",
            status: false
        }
    ]);

    const [pseudo, setPseudo] = useState([
        {
            id: 1,
            libelle: "Prénom et Nom",
            status: false
        },
        {
            id: 2,
            libelle: "Prénom et Initiale du Nom",
            status: false
        },
        {
            id: 3,
            libelle: "Initiale du Prénom et Nom",
            status: false
        },
        {
            id: 4,
            libelle: "Initiales des Prénom et Nom",
            status: false
        }
    ]);

    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [email, setEmail] = useState('');
    const [telephone, setTelephone] = useState('');
    const [codePostal, setCodePostal] = useState('');
    // const [historiqueAvis, setHistoriqueAvis] = useState(false);
    const [affichePseudo, setAffichePseudo] = useState(false);
    const [accept, setAccept] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [loadPassword, setLoadPassword] = useState(false);

    const [password, setPassword] = useState('');
    const [cpassword, setCpassword] = useState('');




    const client = useSelector((state) => state.client);

    useEffect(() => {
        AfficheDonnerClient();
    }, []);


    const AfficheDonnerClient = () => {
        setLoadData(true);
        AfficheDonner(client.id).then(function (response) {
            console.log("data =>", response.data.donner);


            if (response.data.donner.dateNaissance !== "") {
                setNaissance(new Date(response.data.donner.dateNaissance));
            }

            if (response.data.donner.sexe !== "") {
                setSexe((prev) => {
                    return prev.map((item) => {
                        if (item.libelle === response.data.donner.sexe) {
                            return { ...item, status: true }
                        } else {
                            return { ...item, status: false }
                        }
                    })
                });

            }

            if (response.data.donner.pseudo !== "") {
                setPseudo((prev) => {
                    return prev.map((item) => {
                        if (item.libelle === response.data.donner.pseudo) {
                            return { ...item, status: true }
                        } else {
                            return { ...item, status: false }
                        }
                    })
                });
            }

            setNom(response.data.donner.nom);
            setPrenom(response.data.donner.prenom);
            setTelephone(response.data.donner.telephone);
            setEmail(response.data.donner.email);
            setCodePostal(response.data.donner.adressePostal === "" ? '' : response.data.donner.adressePostal);
            // const historiqueValue = response.data.donner.historiqueAvis === "1" ? true : false;
            const affichePseudoValue = response.data.donner.affichagePseudo === "1" ? true : false;
            // setHistoriqueAvis(historiqueValue);
            setAffichePseudo(affichePseudoValue);
            if (response.data.donner.adressePostal !== "") {
                setAccept(true);
            }
        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }




    let location = useLocation();


    const handleChangeStatus = (id) => {
        setSexe((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, status: true }
                } else {
                    return { ...item, status: false }
                }
            });
        })
    }





    const handleChangePseudoStatus = (id) => {
        setPseudo((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, status: true }
                } else {
                    return { ...item, status: false }
                }
            })
        })
    }




    const handleSubmit = (e) => {
        e.preventDefault();
        setLoadData(true);
        const activeSexe = sexe.find((el) => el.status === true);
        const activePseudo = pseudo.find((el) => el.status === true);


        const data = { nom: nom, prenom: prenom, email: email, telephone: telephone, codePostal: codePostal, sexe: activeSexe.libelle, dateNaissance: naissance, pseudo: activePseudo.libelle, affichagePseudo: affichePseudo };
        ModificationDonner(client.id, data).then(function (response) {
            console.log(response);
            AfficheDonnerClient();
            toast.success(response.data.message);
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }

        }).finally(function () {
            setLoadData(false);
        });
    }


    const handleChangePassword = (e) => {
        e.preventDefault();
        setLoadPassword(true);
        if (password !== cpassword) {
            toast.warning('Mot de passe doit-être égal à confirm mot de passe');
        } else {

            const data = { password: password };
            ModificationPassword(client.id, data).then(function (response) {
                console.log(response);
                toast.success(response.data.message);
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    toast.error(error.response.data?.message);
                }

            }).finally(function () {
                setLoadPassword(false);
                setPassword('');
                setCpassword('');
            });
        }
    }

    return (
        <div>
            <Helmet>
                <title>Données personnelles</title>
                <meta name='description' content='Données personnelles' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='donner'>
                <div className='container'>
                    <div className='bloc_donner'>
                        <div className='titre'>
                            <h1><i className='fa fa-address-book'></i>Données personnelles</h1>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className='liste_donner'>
                                <div className='item_liste check'>
                                    <span>Sexe <i className="etoile">*</i> :</span>
                                    <div className='ms-2'>
                                        {sexe.map((item, i) => {
                                            return (
                                                <div className="form-check form-check-inline" key={i}>
                                                    <input className="form-check-input" required type="radio" name="inlineRadioSexe" id={item.id + "homme"} onChange={() => handleChangeStatus(item.id)} checked={item.status} value={item.id + "sexe"} />
                                                    <label className="form-check-label" htmlFor={item.id + "homme"}>{item.libelle}</label>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className='content_flex'>
                                    <div className='flex_one'>
                                        <div className='item_liste text mt-2'>
                                            <span className='mt-1'>Nom <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <input type="text" required value={nom} onChange={(e) => setNom(e.target.value)} className="form-control" placeholder="Nom ..." />
                                            </div>
                                        </div>
                                        <div className='item_liste text mt-2'>
                                            <span className='mt-1'>Prénom <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <input type="text" required value={prenom} onChange={(e) => setPrenom(e.target.value)} className="form-control" placeholder="Prénom ..." />
                                            </div>
                                        </div>
                                        <div className='item_liste text mt-2'>
                                            <span className='mt-1'>Adresse email <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder="Adresse email ..." />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex_two'>
                                        <div className='item_liste text mt-2'>
                                            <span className='mt-1'>N° de téléphone <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <input type="text" required value={telephone} onChange={(e) => setTelephone(e.target.value)} className="form-control" placeholder="N° de téléphone ..." />
                                            </div>
                                        </div>
                                        <div className='item_liste text mt-2 mb-1'>
                                            <span className='mt-1'>Adresse postale <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <input type="text" required value={codePostal} onChange={(e) => setCodePostal(e.target.value)} className="form-control" placeholder="Adresse postale ..." />
                                            </div>
                                        </div>
                                        <div className='item_liste text mt-2'>
                                            <span className='mt-1'>Date de naissance <i className="etoile">*</i> :</span>
                                            <div className=''>
                                                <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        value={naissance}
                                                        placeholder="10/10/2018"
                                                        required
                                                        onChange={date => setNaissance(date)}
                                                        format="MM/dd/yyyy"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='item_liste select_pseudo mt-3'>
                                    <span className='mt-1'>Pseudo affiché <i className="etoile">*</i> :</span>
                                    <div className='mt-2'>
                                        {pseudo.map((item, i) => {
                                            return (
                                                <div className="form-check form-check-inline" key={i}>
                                                    <input className="form-check-input" type="radio" required name="inlineRadioPseudo" id={item.id + "pseudo"} onChange={() => handleChangePseudoStatus(item.id)} checked={item.status} value={item.id + "pseudo"} />
                                                    <label className="form-check-label" htmlFor={item.id + "pseudo"}>{item.libelle}</label>
                                                </div>
                                            )
                                        })}

                                    </div>
                                </div>
                                <div className='condition'>
                                    <div className='ms-5 mt-2'>
                                        {/* <div className="form-check">
                                            <input className="form-check-input" value={historiqueAvis} checked={historiqueAvis} onChange={() => setHistoriqueAvis(true)} type="checkbox" id="avis" />
                                            <label className="form-check-label" htmlFor="avis">
                                                J’accepte que les autres utilisateurs aient accès à l’historique des avis que j’ai déposés
                                            </label>
                                        </div> */}
                                        <div className="form-check">
                                            <input className="form-check-input" value={affichePseudo} checked={affichePseudo} onChange={() => setAffichePseudo(true)} type="checkbox" id="pseudo" />
                                            <label className="form-check-label" htmlFor="pseudo">
                                                Accepte affichage de mon pseudo sur mes avis
                                            </label>
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        <div className="form-check">
                                            <input className="form-check-input" value={accept} required checked={accept} onChange={() => setAccept(true)} type="checkbox" id="generale" />
                                            <label className="form-check-label" htmlFor="generale">
                                                Acceptation des conditions générales d’utilisation <i className="etoile">*</i>
                                            </label>
                                        </div>
                                    </div>
                                    <span>Champs obligatoires <i className="etoile">*</i></span>
                                </div>
                                {loadData && <div className="d-flex justify-content-center">
                                    <Spinner animation="border" className="load" variant="info" size="md" />
                                </div>}
                                <div className='d-flex justify-content-center mt-4'>
                                    <button type='submit' className='btn btn_register'>Enregistrer</button>
                                </div>
                            </div>
                        </form>
                        <form onSubmit={handleChangePassword}>
                            <div className='password'>
                                <h2>Modifier son mot de passe</h2>
                                <span>Saisir le nouveau mot de passe</span>
                                <div className='form col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                    <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" id="inputPassword" placeholder='Nouveau mot de passe ...' />
                                    <input type="password" required value={cpassword} onChange={(e) => setCpassword(e.target.value)} className="form-control" id="inputPassword" placeholder='Ressaisir le nouveau mot de passe ...' />
                                </div>
                                {loadPassword && <div className="d-flex justify-content-center">
                                    <Spinner animation="border" className="load" variant="info" size="md" />
                                </div>}
                                <div className='d-flex justify-content-center mt-4'>
                                    <button type="submit" className='btn btn_register'>Enregistrer</button>
                                </div>
                            </div>
                        </form>
                        <p className="version">Version 1</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Donner